module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"group-late":"En retard","group-today":"Dû aujourd\u0027hui","group-upcoming":"À venir","group-no-date":"Sans date"},"en":{"group-late":"Late","group-today":"Due today","group-upcoming":"Upcoming","group-no-date":"No date"}}')
  delete Component.options._Ctor
}
